import { Theme, styled, Drawer } from '@material-ui/core';
import { NavigationBarState } from '../../slices/navigationBar/navigationBarSlice';

export const DrawerContainer = styled('div')<Theme>(({ theme }) => ({
  height: '100%',
  backgroundColor: '#ffffff',
  [theme.breakpoints.down('xs')]: {
    display: 'none',
  },
}));

export const DrawerWrapper = styled(Drawer)<Theme>(({ theme }) => ({
  position: 'sticky',
  height: '100%',
  backgroundColor: '#FFF',
  '&.open': {
    '& .MuiDrawer-paperAnchorLeft': {
      width: theme.config.openNavigationBarWidthPx,
    },
  },
  '& .MuiDrawer-paperAnchorLeft': {
    overflowX: 'hidden',
    position: 'sticky',
    cursor: 'pointer',
    width: theme.config.closedNavigationBarWidthPx,
    transition: 'width 0.5s ease',
    backgroundColor: '#FFF',
  },
  marginTop: '0px',
}));

export const DrawerContent = styled('div')<Theme>(({ theme }) => ({
  height: '100%',
  backgroundColor: '#FFF',
  display: 'flex',
  justifyContent: 'start',
  width: '100%',
  boxSizing: 'unset',
  flexDirection: 'column',
}));

export const DrawerItem = styled('div')<Theme, { activecolor: string; tocselected: boolean }>(
  ({ theme, activecolor, tocselected }) => ({
    height: '46px',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    fontWeight: tocselected ? 700 : 300,
    borderRight: tocselected ? `4px solid ${activecolor}` : 'none',
    '& *': { color: tocselected ? activecolor : theme.palette.secondary.main },
    '&.active': {
      backgroundColor: `${activecolor}1A`,
      borderRight: `4px solid ${activecolor}`,
      boxSizing: 'unset',
    },
    '&:hover': {
      borderRight: `3px solid ${theme.config.appbarColors.borderColor}`,
    },
    '&:hover *': {
      color: activecolor ? activecolor : 'none',
      fontWeight: 700,
    },
  })
);

export const DrawerFirstItem = styled('div')<
  Theme,
  { isopen: string; place: NavigationBarState['place'] }
>(({ theme, isopen, place }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: theme.config.closedNavigationBarWidthPx,
  minWidth: theme.config.closedNavigationBarWidth,
  fontSize: '14px',
  transition: 'transform 0.5s ease-in-out',
  paddingLeft: place === 'table-of-contents' ? '12px' : 'inherit',
  '&.book': {
    transform: isopen === 'true' ? 'rotate(180deg)' : 'rotate(0deg)',
    justifyContent: place === 'table-of-contents' ? 'flex-start' : 'center',
  },
}));

export const DrawerSecondItem = styled('div')<
  Theme,
  { isopen: string; place: NavigationBarState['place'] }
>(({ theme, isopen, place }) => ({
  display: isopen === 'true' ? '-webkit-box' : 'none',
  width: `calc(${theme.config.openNavigationBarWidth - theme.config.closedNavigationBarWidth}px)`,
  padding: place === 'table-of-contents' ? '0 8px' : '0px 16px',
  fontSize: '14px',
  lineHeight: '18.2px',
  maxHeight: '36.4px',
  cursor: 'pointer',
  overflow: 'hidden',
  '-webkit-box-orient': 'vertical',
  '-webkit-line-clamp': '2',
  '&.book': {
    fontWeight: 600,
    fontSize: '16px',
    color: theme.config.appbarColors.icon,
  },
  '&.chapter': {
    '& .chapter-title': {
      color: '#000000',
      '&:hover': {
        color: theme.palette.primary.main,
      },
    },
  },
}));

export const ChapterContentWrapper = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
}));
